
<template>
  <!-- <pre v-if="responseData"> testData={{ responseData }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/LATIHAN.png"
        alt="LATIHAN"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>


    <div class="content-wrapper">
      <AppAutocomplete
        v-model="selectedYear"
        label="Tahun"
        :items="years"
        placeholder="Pilih Tahun"
        chips
        class="app-date-picker"
      />
      <h2>Laporan Status Pelaksanaan Kursus/Latihan JKT</h2>
      
      <div class="table-container">
        <table class="status-table">
          <thead>
            <tr>
              <th>Jenis Kursus</th>
              <th>Perancangan {{ selectedYear }}</th>
              <th>Peruntukan {{ selectedYear }}</th>
              <th>Perancangan Kemaskini</th>
              <th>Peruntukan Kemaskini</th>
              <th>Jumlah Pelaksanaan</th>
              <th>Jumlah Peruntukan</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="latihan && latihan.length > 0">
              <tr
                v-for="(item, index) in latihan"
                :key="index"
              >
                <td>Umum</td>
                <td>{{ numberWithCommas(item.general_plan) }}</td>
                <td>RM {{ numberWithCommas(item.general_plan_budget) }}</td>
                <td>{{ numberWithCommas(item.general_update) }}</td>
                <td>RM {{ numberWithCommas(item.general_update_budget) }}</td>
                <td>{{ numberWithCommas(item.general_execute) }}</td>
                <td>RM {{ numberWithCommas(item.general_execute_budget) }}</td>
              </tr>
              <tr
                v-for="(item, index) in latihan"
                :key="'functional-'+index"
              >
                <td>Fungsian</td>
                <td>{{ numberWithCommas(item.functional_plan) }}</td>
                <td>RM {{ numberWithCommas(item.functional_plan_budget) }}</td>
                <td>{{ numberWithCommas(item.functional_update) }}</td>
                <td>RM {{ numberWithCommas(item.functional_update_budget) }}</td>
                <td>{{ numberWithCommas(item.functional_execute) }}</td>
                <td>RM {{ numberWithCommas(item.functional_execute_budget) }}</td>
              </tr>
            </template>

            <tr v-else>
              <td colspan="7">
                No data available
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <Update />
    </div>

    <div class="content-wrapper">   
      <h2>Kursus Umum</h2>
      <div class="chart-wrapper">
        <DoubleBar 
          :chart-data="UmumData"
          :chart-categories="UmumNames"
          :legend-labels="['Perancangan', 'Pelaksanaan']"
          :series-colors="['#0000FF', '#029708']"
        />
      </div>
    </div>

    <div class="content-wrapper">   
      <h2>Kursus Fungsian</h2>
      <div class="chart-wrapper">
        <DoubleBar 
          :chart-data="FungsianData"
          :chart-categories="FungsianNames"
          :legend-labels="['Perancangan', 'Pelaksanaan']"
          :series-colors="['#0000FF', '#029708']"
        />
      </div>
    </div>

    <PrimaryModule />
    <KhidmatPengurusan />
  </AdminBackground>
</template>

<script setup>
import KhidmatPengurusan from '@/components/menu-items/section-menu/khidmat-pengurusan-menu.vue'
import Update from '@/components/updatedData/update.vue'
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'

definePage({
  alias: '/pages/pages/inspektorat/i-tegur',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const { httpGet, numberWithCommas } = useHttpService()

const responseData = ref(null)
const latihan = ref([]) 
const years = ref([2022, 2023])
const selectedYear = ref(2024)

const UmumData = ref([])
const UmumNames = ref([])

const FungsianData = ref([])
const FungsianNames = ref([])

async function loadDataFromApi(year) {
  try {
    const response = await fetch(`https://ejkt.kpkt.gov.my/eprofil/api/gate/management_trainings?year=${year}`)
    const apiResponse = await response.json()

    responseData.value = apiResponse.data?.data || []
    latihan.value = responseData.value 
    
    UmumNames.value = latihan.value.map(() => "Khusus Umum")
    FungsianNames.value = latihan.value.map(() => "Khusus Fungsian")

    UmumData.value = [
      latihan.value.map(item => item.general_plan),
      latihan.value.map(item => item.general_update),
    ]

    FungsianData.value = [
      latihan.value.map(item => item.functional_plan),
      latihan.value.map(item => item.functional_execute),
    ]

  } catch (err) {
    console.error('loadDataFromApi failed:', err)
    responseData.value = []
    latihan.value = []
  }
}


watch(selectedYear, newYear => {
  loadDataFromApi(newYear) 
})

// Initial data load
onMounted(() => {
  loadDataFromApi(selectedYear.value)
})
</script>

<style scoped>
.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%;
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; 
  margin-block-start: 10px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); 
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin: 20px 0;
}

.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  inline-size: 100%;
  max-inline-size: 1400px;
  margin-top: 10px;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: left;
  text-transform: uppercase;
}


/* Table Styling */
.table-container {
  background-color: white; /* White background for the table container */
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Subtle shadow to lift the table */
}

.status-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white; /* White background for the table itself */
}

.status-table th, .status-table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}

.status-table th {
  background-color: #f2f2f2;
  font-weight: bold;
  color: #333;
  text-transform: uppercase;
}

.status-table td {
  color: #000;
}

@media (max-width: 1024px) {
  .content-wrapper {
    padding: 15px;
  }

  .chart-wrapper {
    padding: 15px;
  }

  h2 {
    font-size: 1.4rem;
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 15px;
  }

  .chart-wrapper {
    padding: 15px;
  }

  h2 {
    font-size: 1.4rem;
  }
  .table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
  }

  .status-table {
    min-width: 800px; /* Minimum width to trigger horizontal scrolling */
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  .image-wrapper {
    margin-block-end: 10px;
  }

  .pbt-image {
    max-inline-size: 90%;
  }

  .line-under-image {
    inline-size: 90%;
  }

  h2 {
    font-size: 1.2rem;
    margin-block: 20px 5px;
  }
  .table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .status-table {
    min-width: 800px; /* Minimum width to trigger horizontal scrolling */
  }
}
</style>
